import React from "react";
import PropTypes from "prop-types";
import Async from "react-select/async";
import { components } from "react-select";
import axios from "axios";

const HelperSelect = ({
  value,
  isMulti = false,
  onChange,
  showDefaultOptions = false,
  showClearOnly = false,
}) => {
  const Input = (props) => {
    return <components.Input {...props} />;
  };

  const Option = (props) => {
    const record = props.data.record;
    return (
      <components.Option {...props}>
        <p className="mb-0">{props.children}</p>
        <small className="text-muted">{record.email}</small>
      </components.Option>
    );
  };

  const loadOptions = async (term) => {
    const endpoint = `${
      process.env.REACT_APP_API_URL
    }/admin/users?search=${term}&userType=helper&clearOnly=${
      showClearOnly ? "1" : ""
    }`;
    const results = await axios.get(endpoint);
    const opts = [];

    results.data.data.forEach((item) => {
      opts.push({
        value: item._id,
        label: item.name,
        record: item,
      });
    });

    return opts;
  };

  return (
    <Async
      components={{ Option, Input }}
      isMulti={isMulti}
      isClearable={true}
      isSearchable={true}
      loadOptions={loadOptions}
      onChange={onChange}
      value={value}
      defaultOptions={showDefaultOptions}
      placeholder="Search helpers..."
    />
  );
};

HelperSelect.propTypes = {
  value: PropTypes.any,
  isMulti: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  showDefaultOptions: PropTypes.bool,
};

export default HelperSelect;
